var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["header", { collapsed: !_vm.isSidebarOpen }] }, [
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-title" }, [
      _c("h3", [_vm._v("Digital Credit Transfer")]),
      _vm._v(" "),
      _c("h6", [_vm._v("Backend Environment")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-role" }, [
      _c("span", [_vm._v("Current Role")]),
      _vm._v(" "),
      _c("span", { staticClass: "role-badge" }, [_vm._v("Admin")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }